import type { ComponentType } from 'react'

interface Props {
  icon: ComponentType<{ className?: string; 'aria-hidden'?: boolean | 'true' | 'false' }>
  text: string
  punkte: string[]
}

/** Seiten, deren Rechnung steht, deren Darstellung aber noch folgt. Vorerst nur Admin-Sicht. */
export default function PlaceholderPage({ icon: Icon, text, punkte }: Props) {
  return (
    <div className="q-page">
      <section className="q-panel">
        <div className="q-placeholder-head">
          <span className="q-lensdef-code" aria-hidden="true">
            <Icon className="q-navicon" aria-hidden="true" />
          </span>
          <span className="q-badge q-badge--warn">In Vorbereitung</span>
        </div>
        <p className="q-doc-intro" style={{ marginTop: 14 }}>
          {text}
        </p>
        <ul className="q-bullets" style={{ marginTop: 14 }}>
          {punkte.map((p) => (
            <li key={p}>{p}</li>
          ))}
        </ul>
      </section>
    </div>
  )
}
